import { types, flow } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';
import { pick } from 'lodash';

import TrackingUpdate from './TrackingUpdate';

export default types
  .model('TrackingUpdatesPaginator', {
    isLoading: false,
    error: types.maybeNull(types.string),
    page: 1,
    last_page: 0,
    count: 10,
    total: 0,

    updates: types.array(TrackingUpdate),
    id: 0,
  })
  .views(self => ({
    get hasMorePages() {
      return self.page < self.last_page;
    },
  }))
  .actions(self => ({
    load: flow(function* load(replace = false) {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-shipment-tracking-list', null, {
            id: self.id,
            ...pick(self, ['page', 'count']),
          });
          self.last_page = response.data.last_page;
          self.total = response.data.total;

          if (replace) {
            self.updates = response.data.data;
          } else {
            response.data.data.forEach(instance => self.updates.push(instance));
          }
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
    prevPage() {
      if (self.page > 1) {
        self.page--;
        self.load(true);
      }
    },
    nextPage() {
      if (self.page < self.last_page) {
        self.page++;
        self.load(true);
      }
    },
    loadMore() {
      if (self.page < self.last_page) {
        self.page++;
        self.load();
      }
    },
  }));
